export default from './commenting-disabled';



// WEBPACK FOOTER //
// ./app/components/commenting-disabled/index.js